// extracted by mini-css-extract-plugin
export default {"modal":"DropdownCatalog_modal__Sop7w","modalActive":"DropdownCatalog_modalActive__ICE5N"};